import type { RouteRecordRaw } from 'vue-router'

export const billingRoutes: RouteRecordRaw[] = [
  {
    path: '/billing/dashboard',
    name: 'billing-dashboard',
    component: () => import('./dashboard/pages/BillingDashboardPage.vue')
  },
  {
    path: '/billing/billed-rates',
    name: 'billing-billed-rates',
    component: () => import('./billed-rates/pages/BilledRatesIndexPage.vue')
  },
  {
    path: '/billing/billed-rates/:resellerId',
    name: 'billing-billed-rates-edit',
    component: () => import('./billed-rates/pages/BilledRatesEditPage.vue')
  }
]
